const APP_BUILD_ID = process.env.REACT_APP_BUILD_ID;

function versionJsonUrl() {
  const pub = process.env.PUBLIC_URL || '';
  const prefix = pub.endsWith('/') ? pub.slice(0, -1) : pub;
  return `${prefix}/version.json`;
}

/**
 * In production, compares REACT_APP_BUILD_ID (set at build time from your env) with
 * build/version.json on the server. Bump REACT_APP_BUILD_ID on each deploy; when the
 * server file is newer than the id in the bundle, forces a full reload.
 */
export function initDeploymentVersionReload() {
  if (process.env.NODE_ENV !== 'production' || !APP_BUILD_ID) {
    return;
  }

  let disposed = false;

  async function check() {
    if (disposed) {
      return;
    }
    const url = `${versionJsonUrl()}?_=${Date.now()}`;
    try {
      const res = await fetch(url, {
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) {
        return;
      }
      const data = await res.json();
      if (typeof data.buildId !== 'string' || data.buildId === APP_BUILD_ID) {
        return;
      }
      const last = Number(sessionStorage.getItem('_deploy_reload_ts') || '0', 10);
      const now = Date.now();
      if (now - last < 8000) {
        return;
      }
      sessionStorage.setItem('_deploy_reload_ts', String(now));
      window.location.reload();
    } catch {
      // ignore network / parse errors
    }
  }

  const intervalMs = 5 * 60 * 1000;
  const intervalId = window.setInterval(check, intervalMs);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      check();
    }
  });
  window.addEventListener('focus', check);
  check();

  return () => {
    disposed = true;
    window.clearInterval(intervalId);
  };
}
